import { render, staticRenderFns } from "./item.vue?vue&type=template&id=8af9fdba&scoped=true&"
import script from "./item.js?vue&type=script&lang=js&"
export * from "./item.js?vue&type=script&lang=js&"
import style0 from "./item.vue?vue&type=style&index=0&id=8af9fdba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8af9fdba",
  null
  
)

export default component.exports